import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';
import { StandardNamnService } from '../../pages/standard-namn/standard-namn.service';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
    selector: 'lib-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  loggedInRoute: string = '';
  loading = false;
  isLoggedInSingleOrg$: Observable<boolean>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public auth: AuthService,
    private sessionService: SessionService,
    private standardNamnService: StandardNamnService,
    private destroy: DestroyRef

  ) {
    this.init().then();
    this.isLoggedInSingleOrg$ = this.sessionService.loggedInSingleOrg$;
  }

  async init() {
    try {
      const opts = this.route.snapshot.queryParams as QueryOptions;

      if (opts.code) {
        // Login using OAuth PKCE flow
        const authCode = opts.code;
        await this.setQueryParams({ authCode: null });
        this.loading = true;
        const token = await this.auth.getTokenFromAuthCode(authCode);
        if (token) {
          this.auth.saveSession(token);
          this.sessionService.setUserType(token);
          await this.router.navigate([this.loggedInRoute]);
          this.standardNamnService.load();

        }
      }
    } catch (err) {
      console.error(err);
      this.loading = false;
    }
  }

  async setQueryParams(params: Params) {
    await this.router.navigate([], {
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  ngOnInit(): void {
    this.sessionService.loggedInSingleOrg$.pipe(takeUntilDestroyed(this.destroy)).subscribe((loggedInSingle) => {
      if(loggedInSingle) {
        this.loggedInRoute = 'startsida'
      } else {
        this.loggedInRoute = 'valj-organisation'
      }
    })
  }

  loggaIn() {
    this.auth.login();
  }
}

interface QueryOptions {
  code?: string;
}
